// Public payload for the `customer-user:{id}:unreads:snapshot` channel
// (BL-1486 / BL-1487, ADR 056 — Delivery Record § 4).
//
// The two unread counts a bidder's header renders: the bell badge
// (`unreadNotificationCount`) and, once BL-1490 lands, the Messages badge
// (`unreadDirectMessageCount`). Counts only — never a body. The keys of
// `EMPTY_CUSTOMER_UNREADS_SNAPSHOT` ARE the realtime-only set for rule #32: a
// field here must not also reach the client through a REST envelope or an SSR
// prop on a surface that subscribes to this topic.
//
// Declared ONCE here so the catch-up route (bidder-web) and the publisher
// (`@auctogon/realtime`) cannot drift on the shape the client folds — before
// this file each inlined its own copy of the two-field object.

/** The unread counts one bidder's header subscribes to. */
export interface CustomerUnreadsSnapshot {
    /** Unread rows that are NOT direct messages — the bell badge. */
    unreadNotificationCount: number;
    /** Unread direct messages — the Messages icon's badge (BL-1490). */
    unreadDirectMessageCount: number;
}

/**
 * The pre-catch-up default, and what the catch-up route serves a bidder who has
 * no snapshot row yet. Zeros rather than `undefined` so the bell renders "no
 * unread" instead of never resolving.
 */
export const EMPTY_CUSTOMER_UNREADS_SNAPSHOT: CustomerUnreadsSnapshot = Object.freeze({
    unreadNotificationCount: 0,
    unreadDirectMessageCount: 0,
});
